import omit from 'lodash/omit';
import { parse } from 'qs';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectSettingsData } from '@bvi/admin-panel/entities/search/selectors';
import { IAdminSearchFilterFormData } from '@bvi/admin-panel/feature/search/lib/types';
import { ICaseStatisticsData } from '@bvi/api-interfaces/response/case';
import {
  ResultsCaseCounts,
  ResultsChart,
  ResultsAveragesByYearChart,
  ResultsTable,
  SearchTags,
  buildParametersForSettings,
} from '@bvi/cases-search';

type SearchResultProperties = {
  statisticsData: ICaseStatisticsData;
  isFetching: boolean;
};

export const SearchResult: React.FC<SearchResultProperties> = ({
  statisticsData,
  isFetching,
}) => {
  const location = useLocation();
  const searchParameters = parse(location.search, {
    comma: true,
    ignoreQueryPrefix: true,
  }) as Record<keyof IAdminSearchFilterFormData, string>;

  const searchParametersWithoutPagination = omit(searchParameters, [
    'page',
    'limit',
  ]);

  const settings = useSelector(
    selectSettingsData(
      buildParametersForSettings(searchParametersWithoutPagination),
    ),
  );

  return (
    <>
      <SearchTags data={settings} isLoading={isFetching} />
      {/* StatisticsAlert disabled for admin panel - admins should see all statistics */}
      <ResultsTable
        data={statisticsData}
        isLoading={isFetching}
        tagData={settings}
        showGeometricMean
        shouldSticky
      />
      <ResultsChart data={statisticsData} isLoading={isFetching} />
      <ResultsAveragesByYearChart
        averagesByYear={statisticsData.averagesByYear}
        isLoading={isFetching}
      />
      <ResultsCaseCounts
        data={statisticsData}
        isLoading={isFetching}
        shouldSticky
      />
    </>
  );
};
